//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'CommonTable',
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    columns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    showPagination: {
      type: Boolean,
      default: true
    },
    pagination: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    tableProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    innerPage: function innerPage() {
      return Number(this.pagination.page || 1);
    },
    innerPageSize: function innerPageSize() {
      return Number(this.pagination.limit || 10);
    },
    innerTotal: function innerTotal() {
      return Number(this.pagination.total || 0);
    },
    innerPageSizes: function innerPageSizes() {
      return this.pagination.pageSizes || [10, 20, 30, 40];
    },
    paginationLayout: function paginationLayout() {
      return this.pagination.layout || 'total, sizes, prev, pager, next, jumper';
    }
  },
  methods: {
    getCellValue: function getCellValue(column, row, index) {
      if (typeof column.formatter === 'function') {
        return column.formatter(row, column, row[column.prop], index);
      }
      if (column.prop) return row[column.prop];
      return '';
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.$emit('page-change', page);
      this.$emit('pagination-change', {
        page: page,
        limit: this.innerPageSize
      });
    },
    handleSizeChange: function handleSizeChange(limit) {
      this.$emit('size-change', limit);
      this.$emit('pagination-change', {
        page: 1,
        limit: limit
      });
    }
  }
};